import { normalizeCatalogOptions, normalizeGeoOptions as normalizeGeoCatalogOptions } from '@/utils/catalogOptions';

const requestConfig = {};

export const createCustomerCatalogsState = () => ({
  customerTypeOptions: [],
  sizeOptions: [],
  sectorOptions: [],
  originOptions: [],
  areaOptions: [],
  countryOptions: [],
  stateOptions: [],
  catalogsLoaded: false,
  catalogsLoading: false,
});

export const normalizeOptions = (list) => {
  return normalizeCatalogOptions(list, { useCodeInLabel: false });
};

export const normalizeGeoOptions = (list) => {
  return normalizeGeoCatalogOptions(list)
    .map((option) => {
      const code = String(option?.meta?.code ?? option?.code ?? '').trim();
      if (code === '') {
        return option;
      }

      return {
        ...option,
        value: code,
      };
    });
};

export const fetchCustomerCatalogs = async ({
  canAssignArea,
  customerCatalogsService,
  generalCatalogsService,
  areasService,
}) => {
  const areasPromise = canAssignArea
    ? areasService.index(requestConfig)
    : Promise.resolve({ data: [] });

  const [
    typesResult,
    sizesResult,
    sectorsResult,
    originsResult,
    areasResult,
    countriesResult,
    statesResult,
  ] = await Promise.allSettled([
    customerCatalogsService.getCustomerTypes(requestConfig),
    customerCatalogsService.getCustomerSizes(requestConfig),
    customerCatalogsService.getCustomerSectors(requestConfig),
    customerCatalogsService.getCustomerOrigins(requestConfig),
    areasPromise,
    generalCatalogsService.getCountries(requestConfig),
    generalCatalogsService.getStates(requestConfig),
  ]);

  const successfulRequests = [
    typesResult,
    sizesResult,
    sectorsResult,
    originsResult,
    areasResult,
    countriesResult,
    statesResult,
  ].filter((result) => result.status === 'fulfilled').length;

  return {
    customerTypeOptions: normalizeOptions(typesResult.status === 'fulfilled' ? typesResult.value?.data : []),
    sizeOptions: normalizeOptions(sizesResult.status === 'fulfilled' ? sizesResult.value?.data : []),
    sectorOptions: normalizeOptions(sectorsResult.status === 'fulfilled' ? sectorsResult.value?.data : []),
    originOptions: normalizeOptions(originsResult.status === 'fulfilled' ? originsResult.value?.data : []),
    areaOptions: normalizeOptions(areasResult.status === 'fulfilled' ? areasResult.value?.data : []),
    countryOptions: normalizeGeoOptions(countriesResult.status === 'fulfilled' ? countriesResult.value?.data : []),
    stateOptions: normalizeGeoOptions(statesResult.status === 'fulfilled' ? statesResult.value?.data : []),
    catalogsLoaded: successfulRequests > 0,
  };
};
